var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    fill: 333333,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.09,28.56c-.35,0-.7-.12-.99-.35-.67-.54-.77-1.53-.22-2.19l9-11.01L8.89,3.99c-.54-.67-.45-1.65.22-2.19.67-.54,1.65-.45,2.19.22l9.81,12c.47.57.47,1.4,0,1.97l-9.81,12c-.31.38-.76.57-1.21.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a1326bfc663fac12bb40e6f17da97797.svg";
export { ForwardRef as ReactComponent };